import { Button } from "@mui/material";
import React from "react";
import { createUseStyles } from "react-jss";
import styleVariables from "../style_setup";

const styles = createUseStyles({
  MyButton: (props) => ({
    justifySelf: "center",
    alignSelf: "center",
    width: "auto",
    ...props.customStyles,
  }),
  [`@media ${styleVariables.media.smallscreen}`]: {},
});

export const MyButton = ({
  children,
  variant = "contained",
  type = "button",

  customStyles = {},
  dataTestId,
  ...props
}) => {
  const classes = styles({ customStyles });

  return (
    <Button
      className={classes.MyButton}
      {...props}
      data-testid={dataTestId}
      variant={variant}
      type={type}
      sx={{
        textTransform: "capitalize",
        borderRadius: 0,
        // Override disabled styles using sx prop
        "&.Mui-disabled": {
          backgroundColor: "#e0e0e0",
          color: "gray",
        },
      }}
    >
      {children || "Button"}
    </Button>
  );
};
